import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-1/6" }, null, -1)
const _hoisted_3 = { class: "flex-grow" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "mb-2 flex items-end space-x-2" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-3xl" }, "Ajustes")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "w-1/6" }, null, -1)
const _hoisted_6 = { class: "flex items-end space-x-2 mb-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "text-3xl" }, "Ajustes", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "text-center text-2xl mb-6" }, "Eliminar Ajuste", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_table = _resolveComponent("ui-table")
  const _component_table_filter = _resolveComponent("table-filter")
  const _component_ui_table_nav = _resolveComponent("ui-table-nav")
  const _component_ui_button = _resolveComponent("ui-button")
  const _component_ui_modal = _resolveComponent("ui-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    false
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_ui_table, {
              headers: _ctx.headers,
              clickable: true,
              actions: _ctx.actions,
              items: _ctx.items
            }, null, 8, ["headers", "actions", "items"])
          ]),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      (_ctx.userStoreState.role === 'ADMINISTRADOR')
        ? (_openBlock(), _createBlock("p", {
            key: 0,
            class: "cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'ajustes.load' })))
          }, "Crear masivo"))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_table_filter, {
      onFilter: _ctx.onFilterRequest,
      onUnfilter: _ctx.unfilter,
      filters: ['desde', 'hasta', 'origen', 'ruma']
    }, null, 8, ["onFilter", "onUnfilter"]),
    _createVNode(_component_ui_table, _ctx.tableConfig, null, 16),
    _createVNode(_component_ui_table_nav, {
      initial: _ctx.itemsCount.initial,
      actual: _ctx.itemsCount.actual,
      total: _ctx.itemsCount.total,
      onCount: _ctx.onPagedRequest,
      onNext: _ctx.onPageRequest,
      onPrevious: _ctx.onPageRequest,
      perPage: _ctx.filter.qty,
      loading: _ctx.isLoading
    }, null, 8, ["initial", "actual", "total", "onCount", "onNext", "onPrevious", "perPage", "loading"]),
    _createVNode(_component_ui_modal, {
      modalState: _ctx.modalState,
      "onUpdate:modalState": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalState = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_8,
        _createVNode(_component_ui_button, {
          label: "Eliminar",
          loading: _ctx.isDeleting,
          onClick: _ctx.deleteRumaFn
        }, null, 8, ["loading", "onClick"]),
        _createVNode("p", {
          class: "text-center text-yellow-800 py-2 select-none cursor-pointer hover:bg-gray-50 rounded-md transition-all duration-300",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, "Cancelar")
      ]),
      _: 1
    }, 8, ["modalState"])
  ], 64))
}